export default {
  newPreset: 'Neues Prese',
};
